import styled from 'styled-components';

export const Right = styled.div`
  text-align: right;
`;
